import { HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { handleError } from './handleError';

// This is just like the standard way of handling the error except that nobody who calls the
// function will receive any notification when a 202 response happens.
export function handleErrorSilently(
  error: HttpErrorResponse,
  caught: Observable<unknown>,
) {
  return handleError(error, caught, false);
}
